<template>
  <div id="App">
    <router-view />
  </div>
</template>

<script>
import axios from "axios";
import bus from "../static/js/bus";
export default {
  name: "App",
  data() {
    return {
      setting: ""
    };
  },

  mounted: function(e) {
    bus.$on("set", data => {
      this.set();
    });
    var host = window.location.host;
    if(host.split('.').length > 1){
      host = host.substring(host.indexOf(".") + 1,host.length);
    }
    // var domain = "https://m." + host;
    // if (this._isMobile()) {
    //   location.href = domain;
    // }
  },
  methods: {
    set() {
      var that = this;
      axios({
        method: "get",
        url: this.$Http.network + "/v1/setting",
        headers: this.$Http.header(),
        params: {}
      }).then(function(data) {
        var res = data.data;
        if (res.code) {
          localStorage.setItem("setting", JSON.stringify(res.data));
        } else {
          alert(res.msg);
        }
      });
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  }
};
</script>

<style>
.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover {
  cursor: pointer !important;
}
#App{
  /* min-height:100%;
  position:relative; */
}
.el-footer,.el-header{
  padding: 0;
}
.coupon-ctentworld {
  width: 800px;
  height: 600px;
  z-index: 9999;
  overflow: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 5px;
}
.cpn-top {
  padding: 20px;
  background-color: #3490dc !important;
}
.cpn-top p {
  color: #fff;
}
.cpn-main {
  background: #fff;
}
.dhurl {
  width: 100%;
  height: 500px;
  display: block;
}

html {
  background: #f5f5f5;
}
input[type="file"] {
  position: absolute;
  opacity: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
}
.vip {
  width: 26px;
  height: 16px;
  line-height: 16px;
  background: rgba(255, 104, 38, 1);
  border-radius: 10px;
  position: relative;
  text-align: right;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1) !important;
  padding-right: 10px;
}

.vip img {
  width: 20px;
  position: absolute;
  left: -8px;
  top: -3px;
}

@font-face {
  font-family: "YouSheBiaoTiHei";
  src: url("../static/font/YouSheBiaoTiHei-2.ttf");
}
a {
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  -webkit-user-select: none;
  -moz-user-focus: none;
  -moz-user-select: none;
  text-decoration: none;
  cursor: pointer;
}

table tr td:last-child {
  text-align: left;
}

ul li {
  list-style-type: none;
  cursor: pointer;
}
button {
  cursor: pointer;
}
* {
  padding: 0;
  margin: 0;
}

.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.flex-v {
  -webkit-box-orient: vertical;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.flex-1 {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.fwrap {
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  -o-flex-wrap: wrap;
  flex-wrap: wrap;
}

.fvc {
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.fvs {
  -webkit-box-align: start;
  -webkit-align-items: flex-start;
  -ms-flex-align: start;
  align-items: flex-start;
}

.fve {
  -webkit-box-align: end;
  -webkit-align-items: flex-end;
  -ms-flex-align: end;
  align-items: flex-end;
}

.fv-none {
  -webkit-box-align: stretch;
  -webkit-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
}

.fhc {
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.fhsa {
  -webkit-box-pack: justify;
  -webkit-justify-content: space-around;
  -ms-flex-pack: justify;
  justify-content: space-around;
}

.fhsb {
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.fhs {
  -webkit-box-pack: start;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
}

.fhe {
  -webkit-box-pack: end;
  -webkit-justify-content: flex-end;
  -ms-flex-pack: end;
  justify-content: flex-end;
}

.hide1 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}

.hide2 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.hide3 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>



// WEBPACK FOOTER //
// src/App.vue